<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>基地管理</el-breadcrumb-item>
        <el-breadcrumb-item>基地生产数据</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <el-button v-show="baseId" size="small" type="primary" @click="toCreate"> 新增 </el-button>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column align="center" width="60" label="序号">
          <template slot-scope="scope">
            <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
          </template>
        </el-table-column>

        <el-table-column prop="farmTitle" width="100" align="center" label="基地名称"> </el-table-column>

        <el-table-column prop="" width="100" align="center" label="种植位置">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.farmProdutionDataList" :key="index">
              <span>{{ item.areaTitle }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" width="150" align="center" label="亩数/总亩数">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.farmProdutionDataList" :key="index">
              <span>{{ item.measureTotal }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" width="80" align="center" label="品种">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.farmProdutionDataList" :key="index">
              <span>{{ item.categoryTitle }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" width="80" align="center" label="品名">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.farmProdutionDataList" :key="index">
              <span>{{ item.goodTitle }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" width="150" align="center" label="定植时间">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.farmProdutionDataList" :key="index">
              <span>{{ item.plantTime | formatDate }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" width="180" align="center" label="供应开始时间">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.farmProdutionDataList" :key="index">
              <span>{{ item.supplypStarTime | formatDate }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" width="180" align="center" label="供应结束时间">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.farmProdutionDataList" :key="index">
              <span>{{ item.supplypEndTime | formatDate }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" width="120" align="center" label="供应次数">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.farmProdutionDataList" :key="index">
              <span>{{ item.supplyTimes }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" width="180" align="center" label="次供应产量(斤)">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.farmProdutionDataList" :key="index">
              <span>{{ item.supplyTimesProduce }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" align="center" label="总产量">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.farmProdutionDataList" :key="index">
              <span>{{ item.totalProduce }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" align="center" label="亩产">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.farmProdutionDataList" :key="index">
              <span>{{ item.measureProduce }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" align="center" label="审核状态">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.farmProdutionDataList" :key="index">
              <span v-if="item.reviewStatus === 0">通过</span>
              <span v-if="item.reviewStatus === -1">未通过</span>
              <span v-if="item.reviewStatus === 1">待审核</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column width="120" align="center" label="操作">
          <template slot-scope="scope">
            <div class="line-height-style" v-for="(item, index) in scope.row.farmProdutionDataList" :key="index">
              <div v-if="!baseId">
                <el-button v-if="item.reviewStatus === 1" size="small" type="text" @click="openAuditDialog(item.farmProdutionId)"> 审核 </el-button>
              </div>
              <div v-else>
                <el-button size="small" type="text" @click="editItem(scope.row.farmId, scope.row.farmTitle, item)"> 编辑 </el-button>

                <confirm-button size="small" type="text" style="margin: 0 10px" title="确认要删除该条数据？" @confirmed="deleteItem(item.farmProdutionId)">
                  <span>删除</span>
                </confirm-button>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
    <el-dialog class="hx-to-create-template" :title="dialogTitle" :visible.sync="dialogVisible" width="40%" @close="resetDialogForm" :close-on-click-modal="false">
      <div>
        <el-form ref="dialogForm" :model="itemParams" :rules="checkItemParams" label-width="120px">
          <el-form-item label="审核 ：" prop="reviewStatus">
            <el-select style="width: 100%" size="small" v-model="itemParams.reviewStatus" placeholder="请选择审核是否通过">
              <el-option :value="0" label="通过"></el-option>
              <el-option :value="-1" label="拒绝"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button :disabled="isDisabled" size="small" type="primary" @click="auditItem"> 确 认 </el-button>

            <el-button size="small" @click="dialogVisible = false"> 取 消 </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <el-dialog class="hx-to-create-template" title="编辑基地" :visible.sync="editVisible" width="40%" @close="resetEditForm" :close-on-click-modal="false">
      <div v-loading="editLoading">
        <el-form ref="editForm" :model="editParams" :rules="checkEditParams" label-width="150px">
          <el-form-item label="基地名称 ：" prop="farmTitle">
            <span>{{ editParams.farmTitle }}</span>
          </el-form-item>

          <el-form-item label="种植位置 ：" prop="areaId">
            <el-select style="width: 100%" size="small" v-model="editParams.areaId" placeholder="请选择种植位置">
              <el-option v-for="item in farmAreaList" :key="item.areaId" :value="item.areaId" :label="item.areaTitle"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="亩数/总亩数 ：" prop="measureTotal">
            <span>{{ editParams.measureTotal }}</span>
          </el-form-item>

          <el-form-item label="品种 ：" prop="categoryId">
            <el-select style="width: 100%" size="small" v-model="editParams.categoryId" placeholder="请选择品种">
              <el-option v-for="item in farmCategoryList" :key="item.categoryId" :value="item.categoryId" :label="item.categoryTitle"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="品名 ：" prop="goodTitle">
            <el-input size="small" v-model="editParams.goodTitle" placeholder="请输入品名"> </el-input>
          </el-form-item>

          <date-components start-prop="plantTime" :start-date="editParams.plantTime" @set-start-date="getStartDate" date-type="date" date-width="100%" show-type="left" label-name="定植时间：">
          </date-components>

          <date-components
            start-prop="supplypStarTime"
            :start-date="editParams.supplypStarTime"
            @set-start-date="getStartDate"
            date-type="date"
            date-width="100%"
            show-type="left"
            label-name="供应开始时间："
          >
          </date-components>

          <date-components
            start-prop="supplypEndTime"
            :start-date="editParams.supplypEndTime"
            @set-start-date="getStartDate"
            date-type="date"
            date-width="100%"
            show-type="left"
            label-name="供应结束时间："
          >
          </date-components>

          <el-form-item label="供应次数 ：" prop="supplyTimes">
            <span>{{ editParams.supplyTimes }}</span>
          </el-form-item>

          <el-form-item label="每次供应产量(斤) ：" prop="totalProduce">
            <el-input size="small" v-model="editParams.totalProduce" placeholder="请输入每次供应产量(斤)"> </el-input>
          </el-form-item>

          <el-form-item label="总产量(斤) ：" prop="totalProduce">
            <span>{{ editParams.totalProduce }}</span>
          </el-form-item>

          <el-form-item label="亩产量(斤) ：" prop="measureProduce">
            <span>{{ editParams.measureProduce }}</span>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary" @click="saveEdit('editForm')" :disabled="editDisabled"> 保 存 </el-button>
            <el-button size="small" @click="editVisible = false"> 返 回 </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      baseId: "",
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      isDisabled: false,
      dialogTitle: "审核",
      dialogVisible: false,
      itemParams: {
        reviewStatus: 0,
      },
      farmProdutionId: "",
      checkItemParams: {
        reviewStatus: [{ required: true, message: "请选择审核是否通过", trigger: "change" }],
      },
      farmAreaList: [],
      farmCategoryList: [],
      editVisible: false,
      editLoading: false,
      editParams: {
        farmId: "",
        farmTitle: "",
        farmProdutionId: "",
        areaTitle: "",
        measureTotal: "",
        categoryTitle: "",
        goodTitle: "",
        plantTime: "",
        supplypStarTime: "",
        supplypEndTime: "",
        supplyTimes: "",
        supplyTimesProduce: "",
        totalProduce: "",
        measureProduce: "",
        reviewStatus: "",
        areaId: "",
        categoryId: "",
      },
      checkEditParams: {
        areaId: [{ required: true, message: "请选择种植位置", trigger: "change" }],
        categoryId: [{ required: true, message: "请选择品种", trigger: "change" }],
      },
      editDisabled: false,
    };
  },

  mounted() {
    this.loadTableData();
  },
  methods: {
    /**
     * 加载列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      const bodyParams = Object.assign(
        {},
        {
          pageIndex: this.pager.pageIndex,
          pageSize: this.pager.pageSize,
        }
      );
      if (this.baseId) {
        bodyParams.farmId = this.baseId;
      }
      this.$http({
        url: global.apiUrl + "/farm/farm-production-index",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 新增分类管理
     */
    toCreate() {
      this.$router.push({
        name: "addBaseProductionData",
      });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 打开审核对话框
     * @param farmProdutionId
     */
    openAuditDialog(farmProdutionId) {
      this.farmProdutionId = farmProdutionId;
      this.dialogVisible = true;
    },
    /**
     * 审核条目数据
     */
    auditItem() {
      this.isDisabled = true;
      this.$http({
        url: global.apiUrl + "/farm/farm-review-status-affirm",
        method: "PUT",
        body: {
          reviewStatus: this.itemParams.reviewStatus,
          farmProdutionId: this.farmProdutionId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.dialogVisible = false;
            this.isDisabled = false;
            this.loadTableData();
          } else {
            this.isDisabled = false;
          }
        })
        .catch(err => {
          this.isDisabled = false;

          console.error(err);
        });
    },
    /**
     * 编辑条目数据
     * @param farmId
     * @param farmTitle
     * @param row
     */
    editItem(farmId, farmTitle, row) {
      Object.assign(row, {
        farmId: farmId,
        farmTitle: farmTitle,
      });
      this.editLoading = true;
      setTimeout(() => {
        this.editLoading = false;
      }, 500);
      this.editVisible = true;
      this.loadFarmAreaList();
      this.loadCategoryList();
      this.editParams = row;
    },
    /**
     * 初始化种植位置下拉框列表
     */
    loadFarmAreaList() {
      this.$http({
        url: global.apiUrl + "/farm/farm-area",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.farmAreaList = res.body.data.dataList;
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化品种下拉框列表
     */
    loadCategoryList() {
      this.$http({
        url: global.apiUrl + "/farm/farm-category",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.farmCategoryList = res.body.data.dataList;
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 父组件获取子组件传递的开始日期
     * @param startAttr
     * @param startDate
     */
    getStartDate(startAttr, startDate) {
      if (startDate !== "") {
        this.editParams[startAttr] = new Date(startDate).getTime();
      } else {
        this.editParams[startAttr] = "";
      }
    },
    /**
     * 保存修改数据
     * @param name
     */
    saveEdit(name) {
      this.editDisabled = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.editParams.supplypStarTime > this.editParams.supplypEndTime) {
            this.$message.error("开始时间不能大于结束时间");
            this.editDisabled = false;
            return;
          }
          this.$http({
            url: global.apiUrl + "/farm/farm-production-change",
            method: "PUT",
            body: this.editParams,
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.$message.success(res.body.info);
                this.editVisible = false;
                this.editDisabled = false;
                this.loadTableData();
              } else {
                this.editDisabled = false;
              }
            })
            .catch(err => {
              this.editDisabled = false;

              console.error(err);
            });
        } else {
          this.editDisabled = false;
        }
      });
    },
    /**
     * 删除条目数据
     * @param id
     */
    deleteItem(id) {
      this.$http({
        url: global.apiUrl + "/farm/farm-production-delete?farmProdutionId=" + id,
        method: "DELETE",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 保存新增或修改
     */
    saveCategoryNameItem() {},
    /**
     * 关闭对话框时重置表单
     */
    resetDialogForm() {
      this.$refs.dialogForm.resetFields();
    },
    /**
     * 关闭编辑对话框时
     */
    resetEditForm() {
      this.$refs.editForm.resetFields();
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.baseId = parseInt(vm.$route.params.baseId);
    });
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
